routesConfig.$inject = ['$stateProvider']

function routesConfig($stateProvider) {
  $stateProvider
    .state('home.byFavorites', {
      url: "compra-rapida/carga-rapida-por-favoritos",
      template: `<by-favorites sh-ctrl="shCtrl"></by-favorites>`
    })
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-favorites/by-favorites.config.js
 **/